import React from "react";
import "./InfoDetails.css";
import { Link } from "react-router-dom";

const InfoOffice = () => {
  return (
    <div className="info-detail">
      <div className="info-hero office">
        <h2>Gestión de plantas</h2>
        <p>
          La organización de usuarios y equipos se realiza dentro de una
          estructura jerárquica de plantas.
        </p>
      </div>

      <section className="info-section">
        <h3>Estructura jerárquica</h3>
        <ul>
          <li><b>Sucursal</b>: nivel más alto, ubicación física.</li>
          <li><b>Área</b>: división interna de la sucursal.</li>
          <li><b>Sector</b>: subdivisión más específica.</li>
          <li><b>Local</b>: punto final de operación.</li>
        </ul>
      </section>

      <section className="info-section alt">
        <h3>Asignación de usuarios</h3>
        <p>
          Cada usuario debe estar vinculado a una planta para acceder solo a la
          información que le corresponde.
        </p>
      </section>

      <section className="info-flow">
        <h3>Flujo de organización de plantas</h3>
        <ol>
          <li>Un <b>Admin-master</b> crea la <b>sucursal</b> principal.</li>
          <li>Dentro de la sucursal, se crean <b>áreas</b> según la estructura.</li>
          <li>Las áreas se subdividen en <b>sectores</b>.</li>
          <li>Opcionalmente, se definen <b>locales</b> como puntos finales.</li>
          <li>Los usuarios se asignan a uno de estos niveles para limitar su alcance.</li>
        </ol>
      </section>


      <div className="info-cta">
        <h4>¿Listo para organizar tus plantas?</h4>
        <Link to="/admin/lists?show=companies" className="cta-button">
          Configurar estructura
        </Link>
      </div>
    </div>
  );
};

export default InfoOffice;
